import { ActionIcon, Flex, Text } from '@mantine/core';
import { IconEdit as EditIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface CriteriaItemEditButtonProps {
  index?: number;
  onEdit: () => void;
}

export function CriteriaItemEditButton({ index, onEdit }: CriteriaItemEditButtonProps) {
  const { t } = useTranslation();

  return (
    <Flex
      align="center"
      mr="10px"
    >
      {index != null && (
        <Text
          fw="500"
          mr="5px"
        >
          #{index + 1}
        </Text>
      )}
      <ActionIcon
        mr="5px"
        onClick={onEdit}
        variant="filled"
        aria-label={t('button.edit')}
      >
        <EditIcon
          style={{ width: '70%', height: '70%' }}
          stroke={1.5}
        />
      </ActionIcon>
    </Flex>
  );
}
